import { withResetState } from "store/hocs";

import { financialConstants } from "./financial.constants";
import { merchantListConstants } from "../../merchantList/merchantList.constants";

var initialState = {
	loading: {
		financials: false,
		bankBalances: false,
	},
	error: {
		financials: "",
		bankBalances: "",
	},
	financials: [],
	bankBalances: [],
};

function merchantFinancials(state = initialState, action) {
	switch (action.type) {
		case merchantListConstants.RESET_MERCHANT_INFO_STATE:
			return {
				...initialState,
			};

		case financialConstants.MERCHANT_FINANCIALS_ADD_LOCAL_FINANCIAL:
			return {
				...state,
				financials: [...state.financials, action.financial].sort(
					(a, b) =>
						new Date(b.dateOfFinancial) -
						new Date(a.dateOfFinancial),
				),
			};
		case financialConstants.MERCHANT_FINANCIALS_EDIT_LOCAL_FINANCIAL:
			const editedFinancials = [...state.financials];
			editedFinancials[action.index] = action.financial;
			return {
				...state,
				financials: editedFinancials.sort(
					(a, b) => new Date(b) - new Date(a),
				),
			};
		case financialConstants.MERCHANT_FINANCIALS_DELETE_LOCAL_FINANCIAL:
			return {
				...state,
				financials: state.financials.filter(
					(x, i) => i !== action.index,
				),
			};

		case financialConstants.MERCHANT_FINANCIALS_ADD_LOCAL_BANK_BALANCE:
			return {
				...state,
				bankBalances: [...state.bankBalances, action.bankBalance].sort(
					(a, b) =>
						new Date(b.bankBalanceDate) -
						new Date(a.bankBalanceDate),
				),
			};
		case financialConstants.MERCHANT_FINANCIALS_EDIT_LOCAL_BANK_BALANCE:
			const editedBankBalances = [...state.bankBalances];
			editedBankBalances[action.index] = action.bankBalance;
			return {
				...state,
				bankBalances: editedBankBalances.sort(
					(a, b) =>
						new Date(b.bankBalanceDate) -
						new Date(a.bankBalanceDate),
				),
			};
		case financialConstants.MERCHANT_FINANCIALS_DELETE_LOCAL_BANK_BALANCE:
			return {
				...state,
				bankBalances: state.bankBalances.filter(
					(x, i) => i !== action.index,
				),
			};

		case financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_REQUEST:
			return {
				...state,
				loading: {
					...state.loading,
					financials: true,
				},
			};
		case financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_SUCCESS:
			return {
				...state,
				loading: {
					...state.loading,
					financials: false,
				},
			};
		case financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					financials: false,
				},
				error: {
					...state.error,
					financials: action.error,
				},
			};
		case financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_REQUEST:
			return {
				...state,
				loading: {
					...state.loading,
					bankBalances: true,
				},
			};
		case financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_SUCCESS:
			return {
				...state,
				loading: {
					...state.loading,
					bankBalances: false,
				},
			};
		case financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_ERROR:
			return {
				...state,
				loading: {
					...state.loading,
					bankBalances: false,
				},
				error: {
					...state.error,
					bankBalances: action.error,
				},
			};

		default:
			return state;
	}
}

export default withResetState(
	{ initialState, }
)(merchantFinancials);
